const parseRole = role => {
  if (role === 'user') return 'member';
  return role;
};

export { parseRole };
